import React from 'react';
import { FormattedMessage } from 'react-intl';

import { Modal } from 'ui-components/components/modal';
import { ModalHeader } from 'ui-components/components/modal/modal-header';
import { ModalBody } from 'ui-components/components/modal/modal-body';

import { ModalPortal } from '../../modal-portal';
import { ErrorBoundary } from '../../error-boundary';
import { FreightProviderRegistration } from '../../../connection-components/freight-provider-registration';

import { messages } from './messages';
import style from './style.module.less';

type FreightProviderRegistrationModalProps = {
  onBack: () => void;
  onClose: () => void;
  onRegisterSuccess: () => void;
  onRegisterFailure: (error?: unknown) => void;
  onError: (error?: unknown) => void;
  providerApiCode?: string;
};

export const FreightProviderRegistrationModal = ({
  onBack,
  onClose,
  onRegisterSuccess,
  onRegisterFailure,
  onError,
  providerApiCode,
}: FreightProviderRegistrationModalProps) => {
  return (
    <ModalPortal onClose={onClose}>
      <ErrorBoundary errorMessageId='freightProviderRegistrationModal' onError={onClose}>
        <Modal className={style['register-freight-provider-modal']}>
          <ModalHeader closeModal={onClose}>
            <FormattedMessage {...messages.modalTitle} />
          </ModalHeader>
          <ModalBody className={style['modal-body']} shouldIgnoreRootFocus>
            <FreightProviderRegistration
              onBack={onBack}
              onCancel={onClose}
              onError={onError}
              onRegisterFailure={onRegisterFailure}
              onRegisterSuccess={onRegisterSuccess}
              providerApiCode={providerApiCode!}
            />
          </ModalBody>
        </Modal>
      </ErrorBoundary>
    </ModalPortal>
  );
};
